import { Link, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { client } from '../api/client'

import "./HomePage.css"

const iconForTeam = team => `/icons/${((Number(team) - 1) % 20) + 1}.svg`
const discoverableResources = []

function HomePage() {
  const user = useSelector(state=>state.user)
  const navigate = useNavigate()
  const [rooms,setRooms]=useState([])
  useEffect(()=>{client.get('/api/classroom').then(({data})=>setRooms([...data.teams].sort(()=>Math.random()-0.5))).catch(e=>alert(e))},[])
  useEffect(()=>{
    // Intentionally fetch the clue as a resource without ever adding it to the page DOM.
    fetch('/image-flag.png')
      .then(response=>response.ok?response.blob():Promise.reject(new Error('resource unavailable')))
      .then(resource=>discoverableResources.push(resource))
      .catch(()=>{})
  },[])
  useEffect(()=>{
    if (user.loginState === -1) {
      window.localStorage.setItem("first login",'user.loginstate === -1')
      navigate('/login')
    }
  },[user,navigate])
  useEffect(()=>{
    window.render_game_to_text = () => JSON.stringify({
      scene:'home',
      currentTeam:user.user.team,
      roomCount:rooms.length,
      visibleEntrances:['game',...rooms.map(room=>`/house/${room.team}`)],
      note:'房间入口只显示图形；页面坐标原点在左上角，x向右、y向下。'
    })
    window.advanceTime = () => {}
    return () => {
      delete window.render_game_to_text
      delete window.advanceTime
    }
  },[rooms,user.user.team])
  return <div className="home-container">
    <div className="home-header">
      <img alt="" width='100%' src="https://images.unsplash.com/photo-1592398191627-25b41eeaa398?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Z2FtYmxpbmd8ZW58MHx8MHx8&auto=format&fit=crop" />
      <div className='home-header-content'>
        <div className='home-header-content-team'>
          <h2>{user.user.team}战队成员：</h2>
          <h3>{user.user.teamMember?.map(item=><span key={item.sid}>{item.sid}{item.name}{`/`}</span>)}</h3>
          <h3 className='flag-h3' style={{color:'white'}}>被你看到了，也算有缘，请拿走吧：🚩{user.user.clues?.media}</h3>
        </div>
      </div>
    </div>
    <div className="home-content">
      <div className="home-content-heading">
        <div>
          <p className="home-eyebrow">THE HOUSE OF CHOICE</p>
          <h2>每扇门都通向一种可能</h2>
          <p>辨认线索，找到属于你们的那一扇门。</p>
        </div>
        <button className="home-logout" onClick={async()=>{await client.post('/api/logout',{});localStorage.removeItem('user');window.location.assign('/login')}}>退出登录</button>
      </div>
      <div className="room-links">
        <Link to="/game" className="room-card game-room" aria-label="进入游戏大厅">
          <img src="/icons/20.svg" alt="游戏大厅入口" />
          <span>游戏大厅</span>
        </Link>
        {rooms.map(room=><Link className="room-card mystery-room" key={room.team} to={'/house/'+room.team} aria-label="进入未知房间">
          <img src={iconForTeam(room.team)} alt="神秘房间入口" />
        </Link>)}
      </div>
    </div>
    
  </div>
}

export default HomePage
